import Client from '../HttpClient';

const baseUrl = `/gateway/wombat-mgt/api/vs/manage-invoice`;

const getInvoiceCardList = (data) => {
	return Client.get(`${baseUrl}/invoices`, data);
};

const getInvoiceCard = (merchantId, id) => {
	return Client.get(
		`${baseUrl}/${merchantId}/invoice/${id}`,
		{},
		{
			responseType: 'blob',
		}
	);
};

export default {
	getInvoiceCardList,
	getInvoiceCard,
};
